import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class MinimumLengthValidationRule extends ValidationRule {
  private minimum: number;

  constructor(minimum: number, key: string) {
    if (!key) {
      key = ValidationTypes.minimumLength;
    }

    super(key);
    this.minimum = minimum;
  }

  isValid(value: any): boolean {
    if (value === null || !value.hasOwnProperty(`length`)) {
      return false;
    }

    return value.length >= this.minimum;
  }
}
